/** In-memory cache for hover-prefetched /stream responses (per tab session). */
const cache = new Map();

const isEntryValid = (entry, gateVersion) => {
  if (!entry?.streamUrl) return false;
  if (
    gateVersion != null
    && entry.gateVersion != null
    && Number(entry.gateVersion) !== Number(gateVersion)
  ) {
    return false;
  }
  if (!entry.expiresAt) return true;
  const expiryMs = new Date(entry.expiresAt).getTime();
  if (Number.isNaN(expiryMs)) return true;
  return expiryMs > Date.now() + 60 * 1000;
};

export const isVideoPlayableReady = (video) =>
  video?.transcodeStatus === 'ready' || video?.playableInBrowser === true;

export const isVideoTranscodePending = (video) =>
  video?.transcodeStatus === 'pending' || video?.transcodeStatus === 'processing';

export const getPrefetchedStream = (videoId, gateVersion) => {
  if (!videoId) return null;
  const entry = cache.get(String(videoId));
  if (!entry || !isEntryValid(entry, gateVersion)) {
    if (entry) cache.delete(String(videoId));
    return null;
  }
  return entry;
};

export const setPrefetchedStream = (videoId, streamRes, gateVersion) => {
  const streamUrl = streamRes?.streamUrl;
  if (!videoId || !streamUrl) return;
  cache.set(String(videoId), {
    streamUrl,
    expiresAt: streamRes.expiresAt,
    codec: streamRes.codec || streamRes.playbackCodec,
    gateVersion: gateVersion != null ? Number(gateVersion) : null,
    audioGated: streamRes.audioGated === true,
  });
};

export const clearPrefetchedStream = (videoId) => {
  if (videoId) cache.delete(String(videoId));
};
